import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, Inject, NgModule, Injectable } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i2 from '@azavista/components/shared';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i4$1 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i4 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i5 from '@azavista/components/selected-items-count';
import { AzavistaSelectedItemsCountModule } from '@azavista/components/selected-items-count';
import * as i2$1 from '@angular/common';
import * as i3 from '@ngx-translate/core';
function AzavistaUpdateFieldValueComponent_azavista_input_field_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 6);
    i0.ɵɵlistener("valueChanged", function AzavistaUpdateFieldValueComponent_azavista_input_field_8_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChanged($event));
    })("invalidValueSet", function AzavistaUpdateFieldValueComponent_azavista_input_field_8_Template_azavista_input_field_invalidValueSet_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInvalidValueSet($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("field", ctx_r1.data.selectedField)("editMode", ctx_r1.valueFieldEditMode)("canEdit", true)("options", ctx_r1.getFieldOptions(ctx_r1.data.selectedField.id))("fullWidth", true);
  }
}
const SELECT_FIELDS = ['select', 'multi-select', 'from-multi-select', 'virtual-relation', 'virtual-object_enum'];
const TEXT_FIELDS = ['text', 'virtual-textarea'];
let AzavistaUpdateFieldValueComponent = /*#__PURE__*/(() => {
  class AzavistaUpdateFieldValueComponent {
    constructor(sharedSvc) {
      this.sharedSvc = sharedSvc;
      this.valueSet = new EventEmitter();
      this.valueFieldEditMode = false;
    }
    ngOnInit() {
      this.data.fields = this.data.fields.map(field => {
        // ...field,
        // editable: true, mandatory_for_planners: true
        let mandatory = true;
        const fieldType = this.sharedSvc.getFieldTypeFromField(field);
        if ([...TEXT_FIELDS, ...SELECT_FIELDS, ...(this.data.nonRequiredFieldTypes ?? [])].includes(fieldType)) {
          mandatory = false;
        }
        const clonedField = {
          ...field,
          editable: true,
          mandatory_for_planners: mandatory
        };
        return clonedField;
      });
      let usedFieldIds = null;
      if (this.data.selectedField?.id) {
        usedFieldIds = [this.data.selectedField.id];
      }
      this.availableFields = this.sharedSvc.getVisibleAndUsedFields(this.data.fields, usedFieldIds);
      this.fieldSelectField = {
        id: 'field_selector',
        name: 'field_selector',
        editable: true,
        builtin: false,
        category: '',
        label: '',
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */
      };
      this.fieldSelectFieldValue = {
        items: this.availableFields,
        selected: this.data.selectedField || null,
        displayProperty: 'label'
      };
    }
    getFieldOptions(fieldId) {
      return this.sharedSvc.getFieldOptions(fieldId, this.data.fieldsOptions);
    }
    selectedFieldChanged(change) {
      // We need to recreate the field so put it to null in order for the *niIf to remove the field
      // and set it inside setTimeout later so it will be recreated clean without keeping its previous state
      this.data.selectedField = null;
      this.valueFieldEditMode = true;
      window.setTimeout(() => {
        const selectedField = change.value;
        this.data.selectedField = selectedField;
        const fieldType = this.sharedSvc.getFieldTypeFromField(selectedField);
        if (fieldType === 'boolean') {
          // Simulate false value selected
          const changedArgs = {
            field: selectedField,
            value: false
          };
          this.data.selectedValue = changedArgs;
          this.valueSet.next(changedArgs);
        } else if (fieldType === 'select' && selectedField.schema.enum?.includes('')) {
          // Select field that includes an empty value which in the enum appears as an empty string item
          const changedArgs = {
            field: selectedField,
            value: ''
          };
          this.data.selectedValue = changedArgs;
          this.valueSet.next(changedArgs);
        } else {
          // Each field change should be treated as no value selected
          this.setValueNotProvided();
        }
      });
    }
    onValueChanged(value) {
      this.data.selectedValue = value;
      this.valueSet.next(value);
    }
    onInvalidValueSet(value) {
      this.setValueNotProvided();
    }
    setValueNotProvided() {
      this.data.selectedValue = null;
      this.valueSet.next(null);
    }
    static {
      this.ɵfac = function AzavistaUpdateFieldValueComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaUpdateFieldValueComponent)(i0.ɵɵdirectiveInject(i2.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaUpdateFieldValueComponent,
        selectors: [["azavista-update-field"]],
        inputs: {
          data: "data"
        },
        outputs: {
          valueSet: "valueSet"
        },
        standalone: false,
        decls: 9,
        vars: 5,
        consts: [[1, "container", "azavista-update-field-component", "aza-cmp-two-columns-grid"], [1, "field-label"], ["translate", ""], [1, "aza-cmp-medium-width", 3, "valueChanged", "field", "value", "editMode", "fullWidth"], [1, "value-label"], ["class", "aza-cmp-medium-width", 3, "field", "editMode", "canEdit", "options", "fullWidth", "valueChanged", "invalidValueSet", 4, "ngIf"], [1, "aza-cmp-medium-width", 3, "valueChanged", "invalidValueSet", "field", "editMode", "canEdit", "options", "fullWidth"]],
        template: function AzavistaUpdateFieldValueComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
            i0.ɵɵtext(3, "UPDATE_THIS_FIELD");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "azavista-input-field", 3);
            i0.ɵɵlistener("valueChanged", function AzavistaUpdateFieldValueComponent_Template_azavista_input_field_valueChanged_4_listener($event) {
              return ctx.selectedFieldChanged($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "span", 2);
            i0.ɵɵtext(7, "TO_THIS_VALUE");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, AzavistaUpdateFieldValueComponent_azavista_input_field_8_Template, 1, 5, "azavista-input-field", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("field", ctx.fieldSelectField)("value", ctx.fieldSelectFieldValue)("editMode", true)("fullWidth", true);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.data.selectedField);
          }
        },
        dependencies: [i2$1.NgIf, i3.TranslateDirective, i4.AzavistaInputFieldComponent],
        encapsulation: 2
      });
    }
  }
  return AzavistaUpdateFieldValueComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_EMPTY_VALUES = {
  text: '',
  'virtual-textarea': '',
  boolean: false,
  'multi-select': [],
  'from-multi-select': []
};
let AzavistaUpdateFieldValueDialogComponent = /*#__PURE__*/(() => {
  class AzavistaUpdateFieldValueDialogComponent {
    constructor(dialogRef, data, sharedSvc) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.sharedSvc = sharedSvc;
      this.canProceed = false;
    }
    onValueSet(value) {
      if (this.getDefaultEmptyValue() != undefined) {
        this.canProceed = true;
      } else if (value === null || value === undefined) {
        this.canProceed = false;
      } else {
        this.canProceed = true;
      }
    }
    onCancelClick() {
      this.dialogRef.close();
    }
    onApplyClick() {
      const value = this.data.selectedValue;
      if (value === null || value === undefined) {
        const formattedEmptyValue = {
          field: this.data.selectedField,
          value: this.getDefaultEmptyValue(),
          inputValue: value
        };
        this.data.selectedValue = formattedEmptyValue;
      }
      ;
      this.dialogRef.close(this.data);
    }
    getDefaultEmptyValue() {
      const fieldType = this.sharedSvc.getFieldTypeFromField(this.data.selectedField);
      return DEFAULT_EMPTY_VALUES[fieldType];
    }
    static {
      this.ɵfac = function AzavistaUpdateFieldValueDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaUpdateFieldValueDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaUpdateFieldValueDialogComponent,
        selectors: [["ng-component"]],
        standalone: false,
        decls: 19,
        vars: 13,
        consts: [["mat-dialog-title", "", 1, "aza-cmp-dialog-title"], ["translate", ""], ["mat-dialog-content", "", 1, "field-value-selection", "aza-cmp-dialog-content"], [3, "data"], [3, "valueSet", "data"], ["mat-dialog-actions", "", 1, "aza-cmp-dialog-actions"], ["color", "primary", 1, "aza-cmp-dialog-action-cancel-button", 3, "click"], ["color", "primary", 1, "aza-cmp-dialog-action-apply-button", 3, "click", "disabled"]],
        template: function AzavistaUpdateFieldValueDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2, "UPDATE_FIELD_VALUE");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵelement(4, "azavista-selected-items-count", 3);
            i0.ɵɵelementStart(5, "p", 1);
            i0.ɵɵtext(6, "FOR_ALL_SELECTED_ITEMS");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "azavista-update-field", 4);
            i0.ɵɵlistener("valueSet", function AzavistaUpdateFieldValueDialogComponent_Template_azavista_update_field_valueSet_7_listener($event) {
              return ctx.onValueSet($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5)(9, "azavista-flat-button", 6);
            i0.ɵɵlistener("click", function AzavistaUpdateFieldValueDialogComponent_Template_azavista_flat_button_click_9_listener() {
              return ctx.onCancelClick();
            });
            i0.ɵɵelementStart(10, "span");
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵpipe(13, "uppercase");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "azavista-button", 7);
            i0.ɵɵlistener("click", function AzavistaUpdateFieldValueDialogComponent_Template_azavista_button_click_14_listener() {
              return ctx.onApplyClick();
            });
            i0.ɵɵelementStart(15, "span");
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵpipe(18, "uppercase");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("data", ctx.data.selectedItemsCountData);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("data", ctx.data);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 7, i0.ɵɵpipeBind1(12, 5, "CANCEL")));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.canProceed);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 11, i0.ɵɵpipeBind1(17, 9, "APPLY")));
          }
        },
        dependencies: [i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, i3.TranslateDirective, i4$1.AzavistaButtonComponent, i4$1.AzavistaFlatButtonComponent, i5.AzavistaSelectedItemsCountComponent, AzavistaUpdateFieldValueComponent, i2$1.UpperCasePipe, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AzavistaUpdateFieldValueDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaUpdateFieldValueModule = /*#__PURE__*/(() => {
  class AzavistaUpdateFieldValueModule {
    static {
      this.ɵfac = function AzavistaUpdateFieldValueModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaUpdateFieldValueModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaUpdateFieldValueModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [MatDialogModule, MatInputModule, MatSelectModule, MatFormFieldModule, AzavistaSharedModule, AzavistaButtonModule, AzavistaInputFieldModule, AzavistaSelectedItemsCountModule]
      });
    }
  }
  return AzavistaUpdateFieldValueModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaUpdateFieldValueService = /*#__PURE__*/(() => {
  class AzavistaUpdateFieldValueService {
    constructor(matDialog, sharedSvc) {
      this.matDialog = matDialog;
      this.sharedSvc = sharedSvc;
    }
    showUpdateFieldDialog(data) {
      // let resolve: (value?: IUpdateFieldData | PromiseLike<IUpdateFieldData>) => void;
      // let reject: (reason?: any) => void;
      // const promise = new Promise<IUpdateFieldData>((res, rej) => {
      //     resolve = res;
      //     reject = rej;
      // });
      const promise = this.matDialog.open(AzavistaUpdateFieldValueDialogComponent, {
        data: data
      }).afterClosed().toPromise(); // .subscribe({
      //     next: (dialogResult: IUpdateFieldData) => {
      //         resolve(dialogResult);
      //     }
      // });
      return promise;
    }
    getFieldValues(field) {
      let result = [];
      const fieldType = this.sharedSvc.getFieldTypeFromField(field);
      if (fieldType === 'select') {
        result = [...field.schema.enum];
      } else if (fieldType === 'multi-select') {
        result = [...field.schema.items.enum];
      }
      return result;
    }
    static {
      this.ɵfac = function AzavistaUpdateFieldValueService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaUpdateFieldValueService)(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2.AzavistaSharedService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaUpdateFieldValueService,
        factory: AzavistaUpdateFieldValueService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaUpdateFieldValueService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaUpdateFieldValueComponent, AzavistaUpdateFieldValueDialogComponent, AzavistaUpdateFieldValueModule, AzavistaUpdateFieldValueService, DEFAULT_EMPTY_VALUES, SELECT_FIELDS, TEXT_FIELDS };
